import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "evenodd" }, [
      _createElementVNode("path", { d: "M24 0v24H0V0h24zm-2 2H2v20h20V2z" }),
      _createElementVNode("path", {
        "fill-rule": "nonzero",
        d: "M21 20l-4-6-2 3-6-7-6 10zM20 7a3.001 3.001 0 1 1-6.002-.001 3.001 3.001 0 0 1 6.002 0"
      })
    ], -1)
  ]))]))
}
export default { render: render }